import { useGame } from '@/store/game';

/**
 * Комната закончилась не по нашей воле: истекли десять минут тишины, хост
 * вышел, сервер перезапустился. Экран нужен затем, что состояние партии в
 * сторе ещё лежит, и без него человек остался бы смотреть в живой с виду
 * стол, где ни одна кнопка не работает.
 *
 * Свой уход отличается не по тексту причины (она свободная и меняется на той
 * стороне), а по тому, что `leave` отправляли мы сами — это знает только стор.
 *
 * Возврата в ту же комнату нет: код освобождается сервером сразу и может уже
 * достаться другой компании (docs/backend-contract-changelog.md, шаги У1/У2).
 */
export function ClosedScreen() {
  const reason = useGame((s) => s.closedReason);
  const left = useGame((s) => s.leftByChoice);
  const reset = useGame((s) => s.reset);

  return (
    <div
      className="flex min-h-screen flex-col justify-between bg-ground px-5 text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <div className="flex-1 py-6">
        <h1 className="font-display text-display">{left ? 'ВЫ ВЫШЛИ' : 'КОМНАТА ЗАКРЫТА'}</h1>
        {reason && <p className="mt-3 text-lead text-dim">{reason}</p>}
        <p className="mt-6 text-base text-mute">
          Код уже освободился и мог достаться другой компании — вернуться по нему некуда.
        </p>
      </div>

      <button
        type="button"
        onClick={reset}
        className="flex h-act w-full items-center justify-center bg-acc font-display text-btn uppercase text-ground"
      >
        В начало
      </button>
    </div>
  );
}
